import { ApiStatus } from 'Enums';
import { generateLibreUserAgentHeader, urls } from 'Utilities/dataHelpers';
import log from 'Utilities/log';
import mediator from 'Utilities/mediator';
export const getConnectionsService = (accountId, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'GET',
            url: urls.libreApiCountryUrl + `v1/patients/${accountId}/connections`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
            name: 'getConnections',
        })
            .then((result) => {
            if (result.data) {
                resolve(result.data);
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const deleteCaregiverInvitationService = (accountId, invitationId, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'DELETE',
            url: urls.libreApiCountryUrl +
                `v1/patients/${accountId}/connections/caregivers/invitations/${invitationId}`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
        })
            .then((result) => {
            if (result.status === ApiStatus.NO_CONTENT) {
                resolve();
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const resendCaregiverInviteService = (accountId, invitationId, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'POST',
            url: urls.libreApiCountryUrl +
                `v1/patients/${accountId}/connections/caregivers/invitations/${invitationId}`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
        })
            .then((result) => {
            if (result.status === ApiStatus.NO_CONTENT) {
                resolve();
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const deleteCaregiverConnectionService = (accountId, caregiverID, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'DELETE',
            url: urls.libreApiCountryUrl +
                `v1/patients/${accountId}/connections/caregivers/${caregiverID}`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
        })
            .then((result) => {
            if (result.status === ApiStatus.NO_CONTENT) {
                resolve();
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const inviteCaregiverService = (email, firstName, lastName, accountId, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'POST',
            url: urls.libreApiCountryUrl + `v1/patients/${accountId}/connections/caregivers/invitations`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
            data: {
                email,
                firstName,
                lastName,
            },
        })
            .then((result) => {
            if (result.data) {
                resolve(result.data);
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const acceptOrRejectPracticeInvitationService = (invitationID, accountID, action, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'POST',
            url: urls.libreApiCountryUrl +
                `v1/patients/${accountID}/connections/practices/invitations/${invitationID}`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
            data: {
                action,
            },
        })
            .then((result) => {
            if (result.status === ApiStatus.OK && result.data) {
                resolve(result.data);
                return;
            }
            if (result.status === ApiStatus.NO_CONTENT) {
                resolve();
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const validatePracticeService = (businessID, accountID, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        const encodedBusinessID = encodeURIComponent(businessID);
        mediator
            .request('api:invoke', {
            method: 'GET',
            url: urls.libreApiCountryUrl +
                `v1/patients/${accountID}/connections/practices/${encodedBusinessID}`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
        })
            .then((result) => {
            if (result.data) {
                resolve(result.data);
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const addPracticeService = (practiceID, accountID, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'POST',
            url: urls.libreApiCountryUrl + `v1/patients/${accountID}/connections/practices/${practiceID}`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
        })
            .then((result) => {
            if (result.data) {
                resolve(result.data);
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const removePracticeService = (practiceID, accountID, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'DELETE',
            url: urls.libreApiCountryUrl + `v1/patients/${accountID}/connections/practices/${practiceID}`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
        })
            .then((result) => {
            if (result.status === ApiStatus.OK) {
                resolve();
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const removePartnerService = (partnerID, accountID, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'DELETE',
            url: urls.libreApiCountryUrl + `v1/patients/${accountID}/connections/partners/${partnerID}`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
        })
            .then((result) => {
            if (result.status === ApiStatus.NO_CONTENT) {
                resolve();
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const createNewDataShareService = (accountID, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'POST',
            url: urls.libreApiCountryUrl + `v1/patients/${accountID}/connections/data-share`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
        })
            .then((result) => {
            if (result.data) {
                resolve(result.data);
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const stopDataShareService = (accountID, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'DELETE',
            url: urls.libreApiCountryUrl + `v1/patients/${accountID}/connections/data-share`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
        })
            .then((result) => {
            if (result.status === ApiStatus.OK) {
                resolve();
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const sharingCodeValidateService = (code, yearOfBirth, accountID, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'POST',
            url: urls.libreApiCountryUrl +
                `v1/patients/${accountID}/connections/partners/sharing-code/validate`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
            data: {
                code,
                yearOfBirth,
            },
        })
            .then((result) => {
            if (result.data) {
                resolve(result.data);
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
